// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eATcObE60elvuBThN9mD {
	display: flex;
	align-items: center;
	gap: 5px;
	width: 100%;
	height: 16px;
	padding: 0 8px;
	/* TRADEMARK_FIX (V-06): border-box keeps the 100%-wide root exactly inside
	the wrapper instead of bleeding past the pane edge. The trademark itself
	is in normal flow (see .trademark), never absolute over canvas. */
	box-sizing: border-box;
	position: relative;
	background: color-mix(in srgb, var(--vnsc-bg-secondary, var(--vnsc-bg, #131722)) 92%, transparent);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
	border-bottom: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.16));
	pointer-events: auto;
	user-select: none;
	overflow: hidden;
}

/* V-05: inactive signaled by border only — figures stay full contrast (WCAG). */
.SnJkE_vRZtg_k7vzfX1z {
	opacity: 1;
}

.BcgKTiit6d3HAFbGikfO {
	display: flex;
	align-items: center;
	gap: 5px;
	flex: 1 1 auto;
	min-width: 0;
	overflow: hidden;
}

.IRyH7u6SITmQlbSNvZM6 {
	border: none;
	background: transparent;
	color: var(--vnsc-text-primary, #d1d4dc);
	font-size: 14px;
	font-weight: 700;
	letter-spacing: 0.03em;
	padding: 0;
	cursor: pointer;
	line-height: 1;
	white-space: nowrap;
	flex-shrink: 0;
	/* UIUX S3: ticker truncate trong o 2x2 hep (khong day OHLC). */
	max-width: 120px;
	overflow: hidden;
	text-overflow: ellipsis;
	transition: color 0.15s ease;
}

.IRyH7u6SITmQlbSNvZM6:hover {
	color: var(--vnsc-text-link);
}

.Jh0mmpGQFgSk3ty7n4R5 {
	color: var(--vnsc-text-primary, #d1d4dc);
}

.y_84isKT35DZO_ajeGPn {
	/* V-05: ~60% of primary weight (was muted #5d606b ≈25%, WCAG fail). */
	color: var(--vnsc-text-secondary, #727f8c);
}

.wi1TXfiMgCX8mrN0xh0S {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	color: #fff;
	font-size: 10px;
	font-weight: 700;
	line-height: 1;
	flex-shrink: 0;
	margin-right: 1px;
}

.peUE4Zcp4272YVeQ8JwE {
	display: inline-flex;
	align-items: center;
	height: 14px;
	padding: 0 5px;
	border-radius: 3px;
	background: var(--vnsc-surface, rgba(255, 255, 255, 0.08));
	color: var(--vnsc-text-secondary, #787b86);
	font-size: 9px;
	font-weight: 600;
	letter-spacing: 0.03em;
	line-height: 1;
	flex-shrink: 0;
}


/* V-06: trademark in normal flex flow at row end (was absolute top-right over
   the gutter/latest candles). Never overlaps canvas by construction. */
/* V-07: exchange tag parity with single-mode statusline. */
.K2jukxk0bTmqhC7YzCA2 {
	color: var(--vnsc-text-secondary, #787b86);
	font-size: 9px;
	font-weight: 700;
	letter-spacing: 0.04em;
	border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.16));
	border-radius: 3px;
	padding: 0 3px;
	line-height: 1.5;
	white-space: nowrap;
	flex-shrink: 0;
}

.OHVjVOsrcyBDmPStcUDM {
	position: static;
	height: 16px;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
	/* TRADEMARK-ALIGN: .header has 8px right padding + overflow hidden, which
	   parks the pill left of the 48px Y-axis gutter. Pull it exactly 8px so
	   its right edge goes flush with the pane edge — the "vninvest" text
	   then centers over the axis column. Larger shifts would clip. */
	margin-right: -8px;
	padding: 0 8px;
	border-radius: 12px;
	/* Solid backdrop (matches header base) hides canvas ticks underneath. */
	background: var(--vnsc-bg-secondary, var(--vnsc-bg, #131722));
	border: 1px solid rgba(255, 255, 255, 0.1);
	color: var(--vnsc-text-secondary, #787b86);
	font-size: 10px;
	font-weight: 600;
	line-height: 1;
	text-decoration: none;
	transition: all 0.2s ease;
	z-index: 6;
}

.OHVjVOsrcyBDmPStcUDM:hover {
	background: rgba(41, 98, 255, 0.15);
	border-color: rgba(41, 98, 255, 0.4);
	color: var(--vnsc-text-primary, #d1d4dc);
}

.UM3DYJNhY8XV683p1_sO {
	font-size: 9px;
}

.xzHiIKaPxDRSl0Sknbwm {
	flex: 1;
	min-width: 4px;
}

.JpiaRLpxRTsuvvWGjb3d {
	border: none;
	background: transparent;
	color: var(--vnsc-text-secondary, #787b86);
	padding: 0 2px;
	cursor: pointer;
	font-size: 11px;
	line-height: 1;
	border-radius: 3px;
	display: flex;
	align-items: center;
	height: 16px;
	/* V-05: discoverable at rest (was 0.5, near-invisible). */
	opacity: 0.75;
	transition: opacity 0.15s ease;
	flex-shrink: 0;
}

.JpiaRLpxRTsuvvWGjb3d:hover {
	opacity: 1;
	color: var(--vnsc-text-primary, #d1d4dc);
	background: rgba(255, 255, 255, 0.06);
}

.S0CuXdvYxjYqIgz7qsmG {
	color: var(--vnsc-text-primary, #d1d4dc);
	font-size: 11px;
	font-family: var(--vnsc-font-mono, "SFMono-Regular", "Consolas", monospace);
	font-variant-numeric: tabular-nums;
	letter-spacing: 0.01em;
	white-space: nowrap;
	line-height: 1;
	flex-shrink: 1;
	font-weight: 500;
}

/* Compact density keeps the FULL O/H/L/C readout (bare numbers, smaller type)
   instead of degrading to close-only — the header must stay informative in
   narrow multi-chart cells. Never display:none financial figures here. */
.eATcObE60elvuBThN9mD[data-density="compact"] {
	gap: 4px;
}

.eATcObE60elvuBThN9mD[data-density="compact"] .S0CuXdvYxjYqIgz7qsmG,
.eATcObE60elvuBThN9mD[data-density="compact"] .F872AsUpUEbvA02Op3wo,
.eATcObE60elvuBThN9mD[data-density="compact"] .YuD7Z30JpnFMwN2fbmhp {
	font-size: 10px;
}

.eATcObE60elvuBThN9mD[data-density="compact"] .l6X4oplPnwFfOJGj0Jxl {
	font-size: 9px;
	margin-right: 2px;
	font-weight: 500;
}

/* V-03: one up/down pair (D3). By-field ohlcOpen/High/Low/Close removed. */
.yLPQe1vZ6D4fkBHb4Ex0 {
	color: var(--vnsc-color-bullish, #26a69a);
}

.zb5TI41XWwE9buoEobKh {
	color: var(--vnsc-color-bearish, #ef5350);
}

.l6X4oplPnwFfOJGj0Jxl {
	color: inherit;
	opacity: 0.75;
	font-size: 10px;
	margin-right: 2px;
	font-weight: 600;
}

.P_hKtzLbEVbpAGQkPtMN {
	color: var(--vnsc-text-primary, #d1d4dc);
	font-size: 11px;
	font-family: var(--vnsc-font-mono, "SFMono-Regular", "Consolas", monospace);
	font-variant-numeric: tabular-nums;
	letter-spacing: 0.01em;
	white-space: nowrap;
	line-height: 1;
	overflow: hidden;
}

.F872AsUpUEbvA02Op3wo {
	font-size: 11px;
	font-weight: 600;
	line-height: 1;
	white-space: nowrap;
	flex-shrink: 0;
	font-variant-numeric: tabular-nums;
}

.YuD7Z30JpnFMwN2fbmhp {
	color: var(--vnsc-text-secondary, #787b86);
	font-size: 11px;
	font-family: var(--vnsc-font-mono, "SFMono-Regular", "Consolas", monospace);
	font-variant-numeric: tabular-nums;
	line-height: 1;
	white-space: nowrap;
	flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/widget/components/canvas/PricePaneHeader.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,cAAc;CACd;;kEAEiE;CACjE,sBAAsB;CACtB,kBAAkB;CAClB,kGAAkG;CAClG,0BAA0B;CAC1B,kCAAkC;CAClC,sEAAsE;CACtE,oBAAoB;CACpB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA,gFAAgF;AAChF;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,wCAAwC;CACxC,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,UAAU;CACV,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,cAAc;CACd,+DAA+D;CAC/D,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,sEAAsE;CACtE,0CAA0C;AAC3C;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,0DAA0D;CAC1D,0CAA0C;CAC1C,cAAc;CACd,gBAAgB;CAChB,sBAAsB;CACtB,cAAc;CACd,cAAc;AACf;;;AAGA;uEACuE;AACvE,2DAA2D;AAC3D;CACC,0CAA0C;CAC1C,cAAc;CACd,gBAAgB;CAChB,sBAAsB;CACtB,+DAA+D;CAC/D,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd;;;kEAGiE;CACjE,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,wEAAwE;CACxE,6DAA6D;CAC7D,0CAA0C;CAC1C,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,qBAAqB;CACrB,yBAAyB;CACzB,UAAU;AACX;;AAEA;CACC,mCAAmC;CACnC,oCAAoC;CACpC,wCAAwC;AACzC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,OAAO;CACP,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,0CAA0C;CAC1C,cAAc;CACd,eAAe;CACf,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,0DAA0D;CAC1D,aAAa;CACb,8BAA8B;CAC9B,cAAc;AACf;;AAEA;CACC,UAAU;CACV,wCAAwC;CACxC,qCAAqC;AACtC;;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf,2EAA2E;CAC3E,kCAAkC;CAClC,sBAAsB;CACtB,mBAAmB;CACnB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;;yEAEyE;AACzE;CACC,QAAQ;AACT;;AAEA;;;CAGC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA,2EAA2E;AAC3E;CACC,yCAAyC;AAC1C;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,cAAc;CACd,aAAa;CACb,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,wCAAwC;CACxC,eAAe;CACf,2EAA2E;CAC3E,kCAAkC;CAClC,sBAAsB;CACtB,mBAAmB;CACnB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;CACnB,cAAc;CACd,kCAAkC;AACnC;;AAEA;CACC,0CAA0C;CAC1C,eAAe;CACf,2EAA2E;CAC3E,kCAAkC;CAClC,cAAc;CACd,mBAAmB;CACnB,cAAc;AACf","sourcesContent":[".header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 5px;\r\n\twidth: 100%;\r\n\theight: 16px;\r\n\tpadding: 0 8px;\r\n\t/* TRADEMARK_FIX (V-06): border-box keeps the 100%-wide root exactly inside\r\n\tthe wrapper instead of bleeding past the pane edge. The trademark itself\r\n\tis in normal flow (see .trademark), never absolute over canvas. */\r\n\tbox-sizing: border-box;\r\n\tposition: relative;\r\n\tbackground: color-mix(in srgb, var(--vnsc-bg-secondary, var(--vnsc-bg, #131722)) 92%, transparent);\r\n\tbackdrop-filter: blur(4px);\r\n\t-webkit-backdrop-filter: blur(4px);\r\n\tborder-bottom: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.16));\r\n\tpointer-events: auto;\r\n\tuser-select: none;\r\n\toverflow: hidden;\r\n}\r\n\r\n/* V-05: inactive signaled by border only — figures stay full contrast (WCAG). */\r\n.headerInactive {\r\n\topacity: 1;\r\n}\r\n\r\n.ohlcGroup {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 5px;\r\n\tflex: 1 1 auto;\r\n\tmin-width: 0;\r\n\toverflow: hidden;\r\n}\r\n\r\n.symbol {\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n\tfont-size: 14px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.03em;\r\n\tpadding: 0;\r\n\tcursor: pointer;\r\n\tline-height: 1;\r\n\twhite-space: nowrap;\r\n\tflex-shrink: 0;\r\n\t/* UIUX S3: ticker truncate trong o 2x2 hep (khong day OHLC). */\r\n\tmax-width: 120px;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\ttransition: color 0.15s ease;\r\n}\r\n\r\n.symbol:hover {\r\n\tcolor: var(--vnsc-text-link);\r\n}\r\n\r\n.symbolActive {\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.symbolInactive {\r\n\t/* V-05: ~60% of primary weight (was muted #5d606b ≈25%, WCAG fail). */\r\n\tcolor: var(--vnsc-text-secondary, #727f8c);\r\n}\r\n\r\n.groupBadge {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tborder-radius: 50%;\r\n\tcolor: #fff;\r\n\tfont-size: 10px;\r\n\tfont-weight: 700;\r\n\tline-height: 1;\r\n\tflex-shrink: 0;\r\n\tmargin-right: 1px;\r\n}\r\n\r\n.timeframePill {\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\theight: 14px;\r\n\tpadding: 0 5px;\r\n\tborder-radius: 3px;\r\n\tbackground: var(--vnsc-surface, rgba(255, 255, 255, 0.08));\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tfont-size: 9px;\r\n\tfont-weight: 600;\r\n\tletter-spacing: 0.03em;\r\n\tline-height: 1;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n\r\n/* V-06: trademark in normal flex flow at row end (was absolute top-right over\r\n   the gutter/latest candles). Never overlaps canvas by construction. */\r\n/* V-07: exchange tag parity with single-mode statusline. */\r\n.exchangeTag {\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tfont-size: 9px;\r\n\tfont-weight: 700;\r\n\tletter-spacing: 0.04em;\r\n\tborder: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.16));\r\n\tborder-radius: 3px;\r\n\tpadding: 0 3px;\r\n\tline-height: 1.5;\r\n\twhite-space: nowrap;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.trademark {\r\n\tposition: static;\r\n\theight: 16px;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tflex-shrink: 0;\r\n\t/* TRADEMARK-ALIGN: .header has 8px right padding + overflow hidden, which\r\n\t   parks the pill left of the 48px Y-axis gutter. Pull it exactly 8px so\r\n\t   its right edge goes flush with the pane edge — the \"vninvest\" text\r\n\t   then centers over the axis column. Larger shifts would clip. */\r\n\tmargin-right: -8px;\r\n\tpadding: 0 8px;\r\n\tborder-radius: 12px;\r\n\t/* Solid backdrop (matches header base) hides canvas ticks underneath. */\r\n\tbackground: var(--vnsc-bg-secondary, var(--vnsc-bg, #131722));\r\n\tborder: 1px solid rgba(255, 255, 255, 0.1);\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tfont-size: 10px;\r\n\tfont-weight: 600;\r\n\tline-height: 1;\r\n\ttext-decoration: none;\r\n\ttransition: all 0.2s ease;\r\n\tz-index: 6;\r\n}\r\n\r\n.trademark:hover {\r\n\tbackground: rgba(41, 98, 255, 0.15);\r\n\tborder-color: rgba(41, 98, 255, 0.4);\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.trademarkIcon {\r\n\tfont-size: 9px;\r\n}\r\n\r\n.spacer {\r\n\tflex: 1;\r\n\tmin-width: 4px;\r\n}\r\n\r\n.settingsBtn {\r\n\tborder: none;\r\n\tbackground: transparent;\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tpadding: 0 2px;\r\n\tcursor: pointer;\r\n\tfont-size: 11px;\r\n\tline-height: 1;\r\n\tborder-radius: 3px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\theight: 16px;\r\n\t/* V-05: discoverable at rest (was 0.5, near-invisible). */\r\n\topacity: 0.75;\r\n\ttransition: opacity 0.15s ease;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.settingsBtn:hover {\r\n\topacity: 1;\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n\tbackground: rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.ohlcItem {\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n\tfont-size: 11px;\r\n\tfont-family: var(--vnsc-font-mono, \"SFMono-Regular\", \"Consolas\", monospace);\r\n\tfont-variant-numeric: tabular-nums;\r\n\tletter-spacing: 0.01em;\r\n\twhite-space: nowrap;\r\n\tline-height: 1;\r\n\tflex-shrink: 1;\r\n\tfont-weight: 500;\r\n}\r\n\r\n/* Compact density keeps the FULL O/H/L/C readout (bare numbers, smaller type)\r\n   instead of degrading to close-only — the header must stay informative in\r\n   narrow multi-chart cells. Never display:none financial figures here. */\r\n.header[data-density=\"compact\"] {\r\n\tgap: 4px;\r\n}\r\n\r\n.header[data-density=\"compact\"] .ohlcItem,\r\n.header[data-density=\"compact\"] .change,\r\n.header[data-density=\"compact\"] .volume {\r\n\tfont-size: 10px;\r\n}\r\n\r\n.header[data-density=\"compact\"] .ohlcLabel {\r\n\tfont-size: 9px;\r\n\tmargin-right: 2px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n/* V-03: one up/down pair (D3). By-field ohlcOpen/High/Low/Close removed. */\r\n.ohlcBull {\r\n\tcolor: var(--vnsc-color-bullish, #26a69a);\r\n}\r\n\r\n.ohlcBear {\r\n\tcolor: var(--vnsc-color-bearish, #ef5350);\r\n}\r\n\r\n.ohlcLabel {\r\n\tcolor: inherit;\r\n\topacity: 0.75;\r\n\tfont-size: 10px;\r\n\tmargin-right: 2px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.ohlc {\r\n\tcolor: var(--vnsc-text-primary, #d1d4dc);\r\n\tfont-size: 11px;\r\n\tfont-family: var(--vnsc-font-mono, \"SFMono-Regular\", \"Consolas\", monospace);\r\n\tfont-variant-numeric: tabular-nums;\r\n\tletter-spacing: 0.01em;\r\n\twhite-space: nowrap;\r\n\tline-height: 1;\r\n\toverflow: hidden;\r\n}\r\n\r\n.change {\r\n\tfont-size: 11px;\r\n\tfont-weight: 600;\r\n\tline-height: 1;\r\n\twhite-space: nowrap;\r\n\tflex-shrink: 0;\r\n\tfont-variant-numeric: tabular-nums;\r\n}\r\n\r\n.volume {\r\n\tcolor: var(--vnsc-text-secondary, #787b86);\r\n\tfont-size: 11px;\r\n\tfont-family: var(--vnsc-font-mono, \"SFMono-Regular\", \"Consolas\", monospace);\r\n\tfont-variant-numeric: tabular-nums;\r\n\tline-height: 1;\r\n\twhite-space: nowrap;\r\n\tflex-shrink: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `eATcObE60elvuBThN9mD`,
	"headerInactive": `SnJkE_vRZtg_k7vzfX1z`,
	"ohlcGroup": `BcgKTiit6d3HAFbGikfO`,
	"symbol": `IRyH7u6SITmQlbSNvZM6`,
	"symbolActive": `Jh0mmpGQFgSk3ty7n4R5`,
	"symbolInactive": `y_84isKT35DZO_ajeGPn`,
	"groupBadge": `wi1TXfiMgCX8mrN0xh0S`,
	"timeframePill": `peUE4Zcp4272YVeQ8JwE`,
	"exchangeTag": `K2jukxk0bTmqhC7YzCA2`,
	"trademark": `OHVjVOsrcyBDmPStcUDM`,
	"trademarkIcon": `UM3DYJNhY8XV683p1_sO`,
	"spacer": `xzHiIKaPxDRSl0Sknbwm`,
	"settingsBtn": `JpiaRLpxRTsuvvWGjb3d`,
	"ohlcItem": `S0CuXdvYxjYqIgz7qsmG`,
	"change": `F872AsUpUEbvA02Op3wo`,
	"volume": `YuD7Z30JpnFMwN2fbmhp`,
	"ohlcLabel": `l6X4oplPnwFfOJGj0Jxl`,
	"ohlcBull": `yLPQe1vZ6D4fkBHb4Ex0`,
	"ohlcBear": `zb5TI41XWwE9buoEobKh`,
	"ohlc": `P_hKtzLbEVbpAGQkPtMN`
};
export default ___CSS_LOADER_EXPORT___;
